export default __webpack_public_path__ + "static/noissue-tv-right-4c6a619407b2e81c3228abe639c69faa.svg";